import { Component, inject, OnInit } from '@angular/core';
import { SearchInputComponent } from '../../atoms/search-input/search-input.component';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { NgForOf, NgIf } from '@angular/common';
import { KeyComboButtonComponent } from '../../atoms/key-combo-button/key-combo-button.component';
import { GlobalSearchStore } from '../../../stores/global-search.state';
import { MenuItem } from 'primeng/api';
import { TabMenuModule } from 'primeng/tabmenu';
import { RippleModule } from 'primeng/ripple';
import { BadgeModule } from 'primeng/badge';
import { TableModule } from 'primeng/table';
import { GlobalsStore } from '../../../stores/globals.state';
import { TableRowIndicatorComponent } from '../../atoms/table-row-indicator/table-row-indicator.component';
import { TableRowDataLayerTypeComponent } from '../../atoms/table-row-data-layer-type/table-row-data-layer-type.component';
import { TableRowBookmarkComponent } from '../../atoms/table-row-bookmark/table-row-bookmark.component';
import { LocalStorageService } from '../../../services/local-storage.service';
import { AlertComponent } from '../../atoms/alert/alert.component';
import { TableRowTopicComponent } from '../../atoms/table-row-topic/table-row-topic.component';
import { TableRowStoryComponent } from '../../atoms/table-row-story/table-row-story.component';
import { TableRowColorsetComponent } from '../../atoms/table-row-colorset/table-row-colorset.component';

@Component({
  selector: 'app-global-search',
  standalone: true,
  imports: [
    SearchInputComponent,
    DialogModule,
    ButtonModule,
    NgIf,
    KeyComboButtonComponent,
    TabMenuModule,
    RippleModule,
    BadgeModule,
    TableModule,
    TableRowIndicatorComponent,
    TableRowDataLayerTypeComponent,
    TableRowBookmarkComponent,
    TableRowStoryComponent,
    TableRowColorsetComponent,
    TableRowTopicComponent,
    NgForOf,
    AlertComponent,
  ],
  templateUrl: './global-search.component.html',
  styleUrl: './global-search.component.scss',
})
export class GlobalSearchComponent implements OnInit {
  readonly globalSearchStore = inject(GlobalSearchStore);
  readonly globalStore = inject(GlobalsStore);
  visible: any;
  active = 'indicators';
  searchValues: string[] = [];
  results?: { [key: string]: any[] };

  constructor(private localStorageService: LocalStorageService) {}

  tabs: MenuItem[] = [
    {
      label: 'Indikatoren',
      key: 'indicators',
      icon: 'fas fa-ruler-vertical',
      command: event => {
        this.active = 'indicators';
      },
    },
    {
      label: 'Räume/ Standorte',
      key: 'dataLayerTypes',
      icon: 'fas fa-map-location-dot',
      command: event => {
        this.active = 'dataLayerTypes';
      },
    },
    {
      label: 'Ansichten',
      key: 'bookmarks',
      icon: 'fas fa-note-sticky',
      command: event => {
        this.active = 'bookmarks';
      },
    },
    {
      label: 'Berichte',
      key: 'stories',
      icon: 'fas fa-file-lines',
      command: event => {
        this.active = 'stories';
      },
    },
    {
      label: 'Farbsets',
      key: 'colorsets',
      icon: 'fas fa-palette',
      command: event => {
        this.active = 'colorsets';
      },
    },
    {
      label: 'Themen',
      key: 'topics',
      icon: 'fas fa-book-open',
      command: event => {
        this.active = 'topics';
      },
    },
  ];

  /**
   * Initializes the component by retrieving search values from the local storage service
   * and assigns them to the searchValues property.
   *
   * @return {void} This method does not return a value.
   */
  ngOnInit(): void {
    this.searchValues = this.localStorageService.getSearchValues();
  }

  /**
   * Updates the search query and fetches filtered results based on the provided query.
   * Also updates the list of previous search values stored in local storage.
   *
   * @param {string} query - The search query string to update the search criteria.
   * @return {void} Does not return a value.
   */
  search(query: string): void {
    this.globalSearchStore.updateQuery(query);
    this.results = this.globalSearchStore.filteredResults();
    if (this.results) {
      this.localStorageService.addSearchValue(query);
    }
    this.searchValues = this.localStorageService.getSearchValues();
  }

  /**
   * Performs a quick search based on the provided query string.
   *
   * @param {string} query - The search term used to execute the quick search.
   * @return {void} This method does not return anything.
   */
  quickSearch(query: string): void {
    this.search(query);
  }

  /**
   * Closes the current instance by resetting its state.
   * Sets `results` to undefined and makes the instance non-visible.
   *
   * @return {void} Returns nothing. This method alters the state of the instance.
   */
  close(): void {
    this.results = undefined;
    this.visible = false;
  }
}
